export const NEW_CRADLE_TO_GRAVE_FEATURE_FLAG: string = 'enableNewCradleToGrave'
export const NEW_CALL_DETAILS_MEETINGS_FLAG: string = 'enableCallDetailsMeetings'
export const USE_NEW_ENTERPRISE_NAMES_FLAG: string = 'useNewEnterpriseLicenceNames'
export const SHOW_LICENCE_SUMMARY_FLAG: string = 'showLicenceSummary'
// Shows the user modal's "Transcribe calls" toggle (APD-14072). Off, and off when missing, until the backend
// contract (APD-14067) lands.
export const USER_TRANSCRIBE_TOGGLE_FEATURE_FLAG: string = 'enableUserTranscribeToggle'
export const CX_AUDIT_MODE_FEATURE_FLAG: string = 'enableCxaAuditMode'
export const CX_SCORE_FEATURE_FLAG: string = 'enableCXScore'
export const DISABLE_NEW_USER_TUTORIAL_FLAG: string = 'disableNewUserTutorial'
export const ENABLE_NEW_USER_TOUR: string = 'newUserTour'
export const SITE_SURVEY_FEATURE_FLAG: string = 'enableSiteSurvey'
// Offers the TelSys "CX Transcribe" business option (APD-14071). Off, and off when missing, until the backend
// contract (APD-14066) lands.
export const TELSYS_TRANSCRIPTION_OPTION_FEATURE_FLAG: string = 'enableTelSysTranscriptionOption'
export const ENABLE_CXI_DATA: string = 'enableCxiData'
